export const SIGN_IN = '/signin';
export const STOREFRONTS = '/storefronts';
export const DASHBOARD = '/dashboard';
export const PRODUCTS = '/inventory';
export const WEBHOOKS = '/webhooks';
export const LOGIN = '/login';
export const ACCOUNT = '/account';
export const JOIN = '/join';
export const INVOICES = '/invoices';
export const NO_ACCESS = '/noAccess';
export const ORDER_DASHBOARD = '/dashboard/orders';
export const SESSION_DASHBOARD = '/dashboard/sessions';
